var map = {
	"./algae_icon.svg": 8585,
	"./icon_algae.svg": 1266,
	"./icon_biweekly.svg": 3434,
	"./icon_bulb.svg": 6859,
	"./icon_check.svg": 6944,
	"./icon_cross.svg": 9483,
	"./icon_ellipse.svg": 6214,
	"./icon_globe.svg": 1584,
	"./icon_info.svg": 3764,
	"./icon_loader.svg": 3873,
	"./icon_opt1_de.svg": 5418,
	"./icon_opt1_fr.svg": 4017,
	"./icon_opt1_ja.svg": 8325,
	"./icon_opt2_de.svg": 5710,
	"./icon_opt2_fr.svg": 2705,
	"./icon_opt2_ja.svg": 4044,
	"./icon_opt3_de.svg": 8994,
	"./icon_opt3_fr.svg": 5019,
	"./icon_opt3_ja.svg": 493,
	"./icon_soft.svg": 6304,
	"./icon_tooltip.svg.svg": 6155,
	"./icon_volume.svg": 3348,
	"./icon_weekly.svg": 3719,
	"./image_recipe_card.png": 1822,
	"./image_salt.png": 506,
	"./image_supplement.png": 8484,
	"./image_supplementing.png": 9236,
	"./img_map.jpg": 2022,
	"./img_salt_bg.jpg": 586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;